import * as React from 'react'
import { useSelector } from 'react-redux'
import * as _ from 'lodash'
import { IAppState } from '../../redux/reducers'


const outstandingTests = [
    {
        id: 5,
        testName: 'Onboarding Test',
        isOnboardingTest: true,

    }
]

interface TestingProps {

}

const Testing : React.FunctionComponent<TestingProps> = ({}) : JSX.Element => {
    let auth = useSelector((state:IAppState) => state.auth)
    const userRole = auth && auth.userData &&  _.isArray(auth.userData.roles) && auth.userData.roles[0]


    return (
        <div>
            <h3>Testing</h3>
            <p>You have no assigned tests outstanding.</p>
        </div>
    )
}

export default Testing